
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuBar from '../Elements/RemainingBar.vue';
import EuButton from '../Button/Button.vue';
/**
- Make sure the props <b>product</b> has all the datas inside
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralProductCard',
  components: {
    EuCard,
    EuBar,
    EuButton
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set product detail
     */
    product: {
      type: Object,
      required: true
    },
    /**
     * Set button disabled
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    computedBackground(val: any) {
      return `background-image: url(${val})`;
    },
    handleClick(e: any) {
      /**
       * Method to click button
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleClickCard(e: any) {
      /**
       * Method to click card
       * @event card
       * @type {function}
       */
      this.$emit('card', e);
    }
  }
});
